import './index.sass';
import uploadForm from './upload-form';
import initUploadProduct from './upload-product';
import initUploadIllustration from './upload-illustration';
import initUploadAlbums from './upload-albums';
import 'cropper';
import 'cropper/dist/cropper.css';

export default () => {
  $('.upload-form').length && uploadForm();
  $('.upload-page.illustration').length && initUploadIllustration();
  $('.upload-page.product').length && initUploadProduct();
  $('.upload-form.album').length && initUploadAlbums();

  import("jquery-ui/ui/widgets/draggable.js").catch(error => {
    console.log(error);
  });

  import("slick-carousel").catch(error => {
    console.log(error);
  })

  import("slick-carousel/slick/slick.css").catch(error => {
    console.log(error);
  });
}